import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import Hero, { heroImgStyles } from '~components/Hero';
import Panel from '~components/Panel';
import Text, { Bold, ConstrainedText } from '~components/Text';

// Page Navigation
import PageNav from '~components/PageNav';
import AbbottCard from '~components/PageCard/AbbottCard';
import EliLillyCard from '~components/PageCard/EliLillyCard';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Insulet, fabricant d’Omnipod®" desc="Description" />
      <Hero title="Insulet, fabricant d’Omnipod®">
        <StaticImage style={heroImgStyles} src="../../images/omni-pod-hero.jpg" alt="" />
      </Hero>
      <div tw="container">
        <Bold>Assurant le financement continu de la recherche vitale pendant la pandémie</Bold>
        <ConstrainedText>
        Insulet Corporation est le chef de file mondial de la technologie des pompes à insuline sans tube avec son système de gestion de l’insuline Omnipod® et soutient depuis longtemps de nombreuses filiales de FRDJ, y compris ici au Canada.
        </ConstrainedText>
      </div>
      <Panel variant="light">
        <div tw="grid gap-6 items-center lg:(grid-cols-2)">
          <div tw="lg:order-2 max-w-2xl">
            <StaticImage src="../../images/sunlife-jdrf-logo.png" alt="" />
          </div>
          <div tw="lg:order-1">
            <Text tw="text-2xl">
            Lorsque COVID-19 a frappé, il était clair que l’une de nos collectes de fonds en personne la plus importante et la plus réussie, la Marche pour la guérison du diabète Sun Life FRDJ, devrait être considérablement modifiée pour être prudent pour les participants. De là est né le Party DT1 pour une guérison FRDJ présentée par Omnipod®.
            </Text>
          </div>
        </div>
      </Panel>
      <div tw="container">
        <ConstrainedText>
        Cet événement familial d’une journée a réuni (virtuellement) la communauté du DT1 lors d’un événement en ligne pour recueillir des fonds pour la recherche sur le DT1 et faire avancer FRDJ sur la voie d’un monde sans diabète de type 1. Il offrait une occasion amusante de faire du bruit lors de la collecte de fonds et comprenait une foule de vedettes, dont Max Domi, Gloria Loring, Bobby Clarke, George Canyon, Sébastien Sasseville et plus encore.
        </ConstrainedText>
        <ConstrainedText>
        Insulet s’est joint à nous en tant que commanditaire principal d’une nouvelle collecte de fonds non testée. Sans leur soutien crucial, l’événement n’aurait pas pu être aussi réussi. Le Party DT1 pour une guérison FRDJ présentée par Omnipod® s’est tenu le 14 juin 2020 et a permis de récolter plus de 2,5 millions de dollars, un total incroyable pour un nouvel événement organisé durant une pandémie.
        </ConstrainedText>
        <ConstrainedText>
        Nous remercions sincèrement Insulet pour leurs années de soutien incroyablement généreux, et en particulier pour nous avoir aidés à continuer à faire avancer nos recherches au cours de cette dernière année d’incertitude. Ils prouvent constamment qu’ils sont déterminés à assurer une meilleure qualité de vie aux plus de 300 000 Canadiens vivant avec le DT1 aujourd’hui, et un monde un jour sans diabète.
        </ConstrainedText>
        <PageNav previous={<AbbottCard />} next={<EliLillyCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
